import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type MaterialsInBundleResponse = {
    items: Material[];
    total: number;
};

type MaterialsInBundleApiResponse = { data: MaterialsInBundleResponse };

// Legacy raw-response fetcher — still consumed by src/services/bundles/bundle-service.ts.
export const getMaterialsInBundle = (params = {}, pathParams: { id?: number } = {}) =>
    axios.get(`${API_URLS.BUNDLE}/${pathParams.id}/materials`, { params });

export const fetchMaterialsInBundle = (
    bundleId: number,
    params: RequestParams = {}
): Promise<MaterialsInBundleResponse> =>
    (
        axios.get(`${API_URLS.BUNDLE}/${bundleId}/materials`, {
            params
        }) as unknown as Promise<MaterialsInBundleApiResponse>
    ).then((response) => response.data);
